export default __webpack_public_path__ + "static/media/sample.1e074715.txt";